<template>
  <div class="quiz-template">
    <div class="quiz-template3">
      <div
        class="quiz-template3_options"
      >
        <div
          class="quiz-template3_options-item"
          v-for="(item, index) in options"
          v-bind:key="index"
        >
          <div class="quiz-template3_options-img">
            <img :src="item.image" class="quiz-template3_options-img_pic">
            <div class="quiz-template3_options_text">{{item.text}}</div>
          </div>
        </div>
      </div>
      <div
        class="quiz-template3_options"
      >
        <div
          :class="['quiz-template3_options-item', {'quiz-template3_options-item__disabled': showResult !== null}]"
          v-for="(item, index) in options"
          v-bind:key="`answer-${index}`"
          @click="onSelectOption(index, item)"
        ><div class="quiz-template3_options-answer">{{item.answer}}</div></div>
        <div
          class="quiz-template3_result"
          v-if="showResult"
        >
           <Transition
             name="page-transition"
             mode="out-in"
             appear
           >
              <div
                class="quiz-template1_item quiz-template1_item__correct"
                v-if="this.selectedOption.correct"
              >
                <div class="quiz-template3_result_col">
                  <h3 class="quiz-template1_item-result-heading">Верно!</h3>
                  <p class="quiz-template1_item-result-text">{{ resultMessage.correctMessage }}</p>
                </div>
                <div class="quiz-template3_result_col">
                  <button class="button outlined" @click="gotoNextQuest">{{ $c(lastQuest ? 'К результатам' : 'Следующий вопрос') }}</button>
                </div>
              </div>
              <div
                class="quiz-template1_item quiz-template1_item__wrong"
                v-else
              >
                <div class="quiz-template3_result_col">
                  <h3 class="quiz-template1_item-result-heading">Не совсем</h3>
                  <p class="quiz-template1_item-result-text">{{ resultMessage.wrongMessage }}</p>
                </div>
                <div class="quiz-template3_result_col">
                  <button class="button outlined" @click="gotoNextQuest">{{ $c(lastQuest ? 'К результатам' : 'Следующий вопрос') }}</button>
                </div>
              </div>
            </Transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})
class QuizTemplate3 extends Vue {
  @Prop({
    required: true,
    type: Object
  }) quizData
  @Prop({
    required: true,
    type: Object
  }) resultMessage
  @Prop({
    required: true,
    type: Boolean
  }) lastQuest

  showResult = null
  selectedOption = null

  get options () {
    return this.quizData.options
  }

  onSelectOption (index, item) {
    if (this.selectedOption) return true
    this.showResult = (index !== null)
    this.selectedOption = item
  }

  gotoNextQuest () {
    this.$root.$emit('quizNextQuest', this.selectedOption.correct)
    setTimeout(() => {
      this.showResult = null
      this.selectedOption = null
    }, 500)
  }
}
export default QuizTemplate3
</script>

<style lang="scss">
  .quiz-template3 {
    width: 100%;
    &_options {
      width: 100%;
      display: grid;
      grid-template-rows: 1fr;
      grid-row-gap: 16px;
      position: relative;
      margin-bottom: 16px;
      @include media_tablet {
        grid-template-columns: 1fr 1fr 1fr;
        grid-column-gap: 40px;
        margin-bottom: 0;
      }
    }
    &_options-item {
      position: relative;
      &__disabled {
        pointer-events: none;
      }
    }
    &_options-img {
      border-radius: 10px;
      overflow: hidden;
      position: relative;
      &:after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 50%;
        background: linear-gradient(180deg, rgba(25, 25, 25, 0) 0%, rgba(25, 25, 25, 0.7) 100%);
        transition: background-color .3s ease;
      }
    }
    &_options-img_pic {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    &_options_text {
      position: absolute;
      left: 0;
      bottom: 24px;
      width: 100%;
      padding: 0 32px;
      box-sizing: border-box;
      font-style: normal;
      font-weight: normal;
      font-size: 20px;
      line-height: 25px;
      color: #FFFFFF;
      z-index: 1;
    }
    &_options-answer {
      padding: 16px 24px;
      background-color: #000000;
      border-radius: 10px;
      color: #999999;
      transition: all .3s ease;
      border: 1px solid rgba(#666666, 0);
      cursor: pointer;
      @include media_tablet {
        margin-top: 30px;
      }
      &:hover {
        background-color: rgba(#000000, 0);
        color: #ffffff;
        border: 1px solid #666666;
      }
    }
    &_result {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      @include media_tablet {
        top: 30px;
      }
      .quiz-template1_item {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        @include media_tablet {
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
        }
        padding: 48px;
        border-radius: 13px;
      }
      &_col {
        display: flex;
        flex-direction: column;
        justify-content: center;
        &:first-child {
          flex: 1;
        }
        .quiz-template1_item-result-heading {
          text-align: left;
          line-height: 25px;
        }
        .quiz-template1_item-result-text {
          text-align: left;
          margin-bottom: 0;
        }
      }
    }
  }

</style>
